import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import loadStock from 'highcharts/modules/stock'
import loadHighchartsMore from 'highcharts/highcharts-more'
import loadSolidGauge from 'highcharts/modules/solid-gauge'
import loadAnnotations from 'highcharts/modules/annotations'
import Vue from 'vue'

export const loadHighcharts = () => {
  loadStock(Highcharts)
  loadHighchartsMore(Highcharts)
  loadSolidGauge(Highcharts)
  loadAnnotations(Highcharts)
  Vue.use(VueHighcharts, { Highcharts })
}
